__turbopack_context__.v({
  "container": "rank-module-scss-module__ZG2QVa__container",
  "fixContainerSize": "rank-module-scss-module__ZG2QVa__fixContainerSize",
});
